module.exports = __webpack_public_path__ + "static/23a3e569-f855-4fcc-9068-d90e827388f4-350.e1dbbee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-katharines-chapel-window/23a3e569-f855-4fcc-9068-d90e827388f4-350.jpg
// module id = 1094
// module chunks = 168707334958949